import { useTranslation } from 'react-i18next';
import { LANGUAGES, setLanguage } from '../i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  return (
    <select
      className="lang"
      aria-label={t('nav.language')}
      value={LANGUAGES.find((l) => i18n.language.startsWith(l.code.split('-')[0]!))?.code ?? 'en-GB'}
      onChange={(e) => void setLanguage(e.target.value)}
    >
      {LANGUAGES.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
